module.exports = __webpack_public_path__ + "img/cursor.7e2e58d.webp";